/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to true if you want to use the splash screen.
  useCustomCursor: true, // Change this to false if you want the good'ol cursor
  googleTrackingID: "UA-174238252-2",
};

//Home Page
const greeting = {
  title: "Howdy.",
  title2: "Rishabh",
  logo_name: "Bussie.R()",
  nickname: "bassi / rishabh",
  full_name: "Rishabh Bassi",
  subTitle:
    "Machine Learning Engineer, Full Stack Developer, Always learning.",
  resumeLink:
    "https://drive.google.com/file/d/1mkKfrqQ_mCxJnjLnvBeyPtEhR1p4LW56/view?usp=drive_link",
  mail: "mailto:bassirishabh@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/bassirishabh",
  linkedin: "https://www.linkedin.com/in/rishabh-bassi/",
  gmail: "bassirishabh@gmail.com",
  gitlab: " ",
  facebook: "https://www.facebook.com/bassirishabh",
  twitter: "https://twitter.com/bassi_rishabh",
  instagram: "https://www.instagram.com/rishabh_bassi/",
};

const skills = {
  data: [
    {
      title: "Machine Learning & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Proficient Experience of working with Machine Learning, DL Models and NLP Technologies such as BERT",
        "⚡ Extensive Research Experience in ML Domain with 3 publication and 3+ years of working as Research Assistant.",
        "⚡ Certifications by deeplearning.ai and Stanford Online",
        "⚡ Passion to delve deeper into NLP and Generative AI to contribute to Healthcare Domain",
        "⚡ Experience with 10+ Projects ranging from Data Analysis to ML Models, from DL to Generative AI",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "Hugging Face",
          fontAwesomeClassname: "emojione:hugging-face",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "transparent",
            color: "#6E6E6E",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Backend SW development using Python, NodeJS, ExpressJS and Django/Flask",
        "⚡ Building responsive website front end using ReactJS and Angular",
        "⚡ Developing mobile applications using Flutter and native Android",
        "⚡ Backend Firmware Development using C and Python  - SSD FW",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#7377AD",
          },
        },
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#f89820",
          },
        },
        {
          skillName: "Kotlin",
          fontAwesomeClassname: "simple-icons:kotlin",
          style: {
            color: "#5c79df",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#29B0EE",
          },
        },
        {
          skillName: "Rails",
          fontAwesomeClassname: "simple-icons:rails",
          style: {
            color: "#00A7D0",
          },
        },
        {
          skillName: "Visual Basic",
          fontAwesomeClassname: "simple-icons:dot-net",
          style: {
            color: "#029FCE",
          },
        },
        {
          skillName: "Ruby",
          fontAwesomeClassname: "simple-icons:ruby",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "C++",
          fontAwesomeClassname: "simple-icons:cplusplus",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NextJS",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#FFFFFF",
            backgroundColor: "#1D1D1D",
            borderRadius: "50%",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "GraphQL",
          fontAwesomeClassname: "simple-icons:graphql",
          style: {
            color: "#DE33A6",
          },
        },
        {
          skillName: "Android App Development",
          fontAwesomeClassname: "simple-icons:android",
          style: {
            color: "#3DDC84",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },

        {
          skillName: "Wordpress",
          fontAwesomeClassname: "simple-icons:wordpress",
          style: {
            color: "#207297",
          },
        },

        {
          skillName: "VSCode",
          fontAwesomeClassname: "simple-icons:visualstudio",
          style: {
            color: "#207297",
          },
        },

        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
      ],
    },
    {
      title: "Data & Cloud Engineer",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Certified AWS Developer, Cloud Practitioner in handling distributed systems and Faster Processing using Multi cloud architecture Hadoop",
        "⚡ Experience working on multiple cloud platforms, managing web apps on GCP and AWS along with fast-tracking code on GPU",
        "⚡ Leading Data Science Initiatives from developing ETL pipelines and performing analysis for business insights.",
        "⚡ Experience in Parallelizing and Optimizing Code using Open MP, MPI, Multiprocessing",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "Snowflake",
          fontAwesomeClassname: "simple-icons:snowflake",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Netlify",
          fontAwesomeClassname: "simple-icons:netlify",
          style: {
            color: "#38AFBB",
          },
        },
        {
          skillName: "Heroku",
          fontAwesomeClassname: "simple-icons:heroku",
          style: {
            color: "#6863A6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Texas A&M University ",
      subtitle: "Masters in Computer Science",
      logo_path: "tamu.png",
      alt_name: "TAMU",
      duration: "2022 - 2024",
      descriptions: [
        "⚡ Studying Advanced Software Development and Computer Science Concepts( specialization in Machine Learning) maintaining perfect GPA of 4 out of 4. ",
        "⚡ Scholarship and fully funded Masters. Learning Advanced Research Topics in NLP, Info Storage, Cloud Computing and Machine Learning Domain.",
        "⚡ Worked on various impact based projects like TA Management Portal, Neural Machine Translation and Travelix. Active Involvement in extracurricular activities such as Judge of TAMU Hackathon and Conference participant. ",
        "⚡ Coursework Taken : Advanced DS and Algo, Machine Learning, Software Engineering, Data Mining and Analysis, Distributed Systems, Information Storage & Reterival, Parallel Computing, Deep Learning, Network Security, Directed Studies Research on Sentiment Analysis.",
      ],
      website_link: "https://www.tamu.edu/",
    },
    {
      title: "Thapar University",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "ti1.png",
      alt_name: "TIET",
      duration: "2015 - 2019",
      descriptions: [
        "⚡ Graduated with specialization in Machine Learning and Data Analysis with CGPA 9.62. ",
        "⚡ Gold Medalist and Scholarship Holder for Exemplary Academic Performance. Worked with Professors as Research Fellow.",
        "⚡ I have also completed various online courses for ML/DL, Web Development, Mobile App Development, etc. and implemented avrious projects based on courses I learnt.",
        "⚡ Coursework Taken : DS, Algo, Entrepreneurship, OS, DBMS, Computer Architecture, Networking, ML, Image Processing, Theory of Computation, Compiler, Microprocessors,  DL, AI, NLP, Data Analytics, Capstone etc. ",
      ],
      website_link: "https://www.thapar.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Neural Networks and Deep Learning",
      subtitle: "DeepLearning.AI",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/LAZVDQRCRHP4",
      alt_name: "DeepLearning",
      color_code: "#ffc475",
    },
    {
      title:
        "Natural Language Processing with Classification and Vector Spaces",
      subtitle: "DeepLearning.AI",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/JWHUM6AVJHM3",
      alt_name: "DeepLearning",
      color_code: "#ffc475",
    },
    {
      title: "Mastering Data Structures and Algorithms",
      subtitle: "Udemy",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-ac3a4583-a01c-4efa-8ddf-6306d63584df/",
      alt_name: "Udemy",
      color_code: "#ffc475",
    },
    {
      title: "Open Source LLMOps Solutions",
      subtitle: "Duke University",
      logo_path: "coursera_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/verify/FGLOECG6RZQN/",
      alt_name: "Duke",
      color_code: "#1e70c1",
    },
    {
      title: "Apple Certification - AIDP GBI Training",
      subtitle: "Apple",
      logo_path: "apple.jpeg",
      certificate_link: "https://drive.google.com/file/d/1v5Adkf0fI4qw7HbnxVF2MMzYl8l52YKL/view?usp=sharing",
      alt_name: "Apple",
      color_code: "#1e70c1",
    },
    {
      title: "Generative AI with Large Language Models",
      subtitle: "Deep Learning",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/verify/8XPIN1ICMK1M",
      alt_name: "DeepLearning",
      color_code: "#1e70c1",
    },
    {
      title: "Prompt Engineering for ChatGPT",
      subtitle: "Vanderbilt University",
      logo_path: "coursera_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/verify/ILH2U5PNH89X",
      alt_name: "Udemy",
      color_code: "#b190b0",
    },
    {
      title: "Generative AI Essentials: Overview and Impact",
      subtitle: "UMich",
      logo_path: "coursera_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/verify/4594DRASMRCZ",
      alt_name: "ML",
      color_code: "#b190b0",
    },
    {
      title: "Introduction to Large Language Models",
      subtitle: "Google Cloud",
      logo_path: "google_logo.png",
      certificate_link: "https://www.coursera.org/account/accomplishments/verify/ULQJBJBEDVT6",
      alt_name: "Coursera",
      color_code: "#b190b0",
    },
    {
      title: "Practical PHP: Master the Basics and Code Dynamic Websites",
      subtitle: "Udemy",
      logo_path: "coursera_logo.png",
      certificate_link: "https://www.udemy.com/certificate/UC-188V4IU7/",
      alt_name: "PHP",
      color_code: "#b190b0",
    },
    {
      title: "Machine Learning A-Z",
      subtitle: "Udemy",
      logo_path: "coursera_logo.png",
      certificate_link: " ",
      alt_name: "ML",
      color_code: "#b190b0",
    },
    {
      title: "Hands on Internt of Things",
      subtitle: "Coursera",
      logo_path: "coursera_logo.png",
      certificate_link: " ",
      alt_name: "IOT",
      color_code: "#b190b0",
    },
    {
      title: "Deep Learning Specialization",
      subtitle: "deeplearning.ai",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: " ",
      alt_name: "deeplearning.ai",
      color_code: "#47A048",
    },
    {
      title: "Sequence Models",
      subtitle: "deeplearning.ai",
      logo_path: "google_logo.png",
      certificate_link: "",
      alt_name: "deeplearning.ai",
      color_code: "#47A048",
    },
    {
      title: "Convolutional Neural Networks",
      subtitle: "deeplearning.ai",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: "",
      alt_name: "deeplearning.ai",
      color_code: "#47A048",
    },
    {
      title: "Structuring and Deploying Machine Learning Models",
      subtitle: "LinkedIN Learning",
      logo_path: "ll.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/0afda0f02b150d69d06c824f9aba7d8fbd1ec7cf26ffe48789507d9722382f7e",
      alt_name: "linkedin",
      color_code: "#2AAFED",
    },
    {
      title: "Machine Learning ",
      subtitle: "LinkedIN Learning",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/79c01982dfc6d742f731525aec1e568354878735766fa1a3ef65fadb89bd83ea",
      alt_name: "linkedin",
      color_code: "#E2405F",
    },
    {
      title: "Improving Deep Neural Networks",
      subtitle: "deeplearning.ai",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: " ",
      alt_name: "Google",
      color_code: "#E2405F",
    },
    {
      title: "Android App Development",
      subtitle: "Summer Training Intershala",
      logo_path: "is.png",
      certificate_link:
        "https://drive.google.com/drive/u/0/folders/1E65Fu8D10CT_iiYDJ2-8skfpDO0fZSbQ",
      alt_name: "Google",
      color_code: "#8C151599",
    },
    {
      title: "Advanced JAVA Training",
      subtitle: "Industrial Summer Training",
      logo_path: "java.png",
      certificate_link: " ",
      alt_name: "Java",
      color_code: "#8C151599",
    },
    {
      title: "Generative AI",
      subtitle: "DeepLearning.AI",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link: " ",
      alt_name: "DeepLearning",
      color_code: "#8C151599",
    },
    {
      title: "LinkedIN NLP Course",
      subtitle: "LinkedIN Learning",
      logo_path: "ll.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/9ae701859b8925c1b32d4ff528194c5f968b5b25c78e3172b4f181e025ce2348?u=104  ",
      alt_name: "Linkedin",
      color_code: "#fffbf3",
    },
    {
      title: "LinkedIN Excel Course",
      subtitle: "LinkedIN Learning",
      logo_path: "ll.png",
      certificate_link:
        "https://www.linkedin.com/learning/certificates/8f1500872494aa1589bc5c27389188b036daba0224a0d4339aa65565480017bb",
      alt_name: "Linkedin",
      color_code: "#fffbf3",
    },
    {
      title: "AWS Introduction Course",
      subtitle: "AWS",
      logo_path: "aws.png",
      certificate_link: " ",
      alt_name: "Linkedin",
      color_code: "#fffbf3",
    },
    {
      title: "GRE",
      subtitle: "326/340",
      logo_path: "GRE.jpeg",
      certificate_link: " ",
      alt_name: "GRE",
      color_code: "#fffbf3",
    },
    {
      title: "TOEFL",
      subtitle: "101/120",
      logo_path: "ets.png",
      certificate_link: " ",
      alt_name: "TOEFL",
      color_code: "#fffbf3",
    },
    {
      title: "Qualcomm 5G Wireless ",
      subtitle: "Qualcomm Academy Courses",
      logo_path: "5g.jpeg",
      certificate_link: " ",
      alt_name: "Qualcomm",
      color_code: "#fffbf3",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Research",
  description:
    "I am a Software/Machine Learning Engineer with a demonstrated history of working in the industry and driven by a passion to bridge the gap between cutting-edge research and practical implementation to solve complex problems. I am currently working as Machine Learning Engineer at Apple. In past I had a couple of internships at prestigious companies like AMD and LinkedIN and have worked for 4 years as Senior Engineer at Western Digital where I was responsible for driving FW modules development.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Machine Learning Engineer",
          company: "Apple",
          company_url: "https://www.apple.com/",
          logo_path: "apple.jpeg",
          duration: "June 2024 - Present",
          location: "Sunnyvale, CA",
          description:
            "Spearheaded the development of advanced machine learning solutions to meet business team requirements. Enhanced sentiment analysis and natural language processing models, driving intelligent data insights and improved decision-making processes.",
          color: "#f10000",
        },
        {
          title: "Graduate Research Assistant",
          company: "Texas A&M University",
          company_url: "https://www.tamu.edu/",
          logo_path: "tamu.png",
          duration: "August 2022 - May 2023",
          location: "College Station, TX",
          description:
            "Investigating bottlenecks in Data Processing of Synthetic Aperture Radar for Satellites and Optimizing code to fast-track enormous matrix computations using algorithms and parallel computing.",
          color: "#f10000",
        },
        {
          title: "Senior Engineer",
          company: "Western Digital",
          company_url: "https://www.westerndigital.com/",
          logo_path: "wd.png",
          duration: "July 2019 - July 2022",
          location: "Bangalore, KA",
          description:
            " Designed Robust Firmware for Error Handling of XOR to better handle defective NAND Memories. Planned Remodelling of Verification Framework for HW Registers in Firmware itself to avoid redundancies in Validation cycles. Revised Performance Gaps in Existing SSD FW to meet Blue Category Performance Numbers. Deployed Code with 25% increase in Write-Read CDM Benchmark. I have equal exposure in various Innovative Forums such as Innovation Bazaar, SDC 2020 and Hackathons",
          color: "#2962FF",
        },
      ],
    },
    {
      title: "Internships",
      experiences: [
        {
          title: "Co-op Software Intern",
          company: "AMD",
          company_url: "https://www.amd.com/",
          logo_path: "amd.png",
          duration: "Jan 2024 - May 2024",
          location: "Austin, TX",
          description:
            "As part of the Research and Development Team at AMD, I developed high-performance software (HPC) & hardware leveraging expertise in Python, deep learning, GPUs, resulting in impactful innovations influencing different machine learning benchmarks and future product roadmaps. Actively contributed to the Advancements in GPU technology for distributed ML heavy benchmarks by doing performance modeling of LLM models & optimizing software design to eliminate bottlenecks in GPU communication.",
          color: "#ee3c26",
        },
        {
          title: "Software Intern",
          company: "LinkedIn",
          company_url: "https://www.linkedin.com/",
          logo_path: "linkedin.png",
          duration: "May 2023 - Aug 2023",
          location: "Mountain View, CA",
          description:
            "Worked as a Summer Intern at LinkedIn where I designed Real Time Automation framework with SQL Database to solve Conflict Resolutions. For the most part, the MySQL team does not have any awareness of several incidents of data divergence due to bugs unless reported by our users. Hence designed a automation framework to detect and report such discrepancies. Active involvement in leadership forums such as SiteCon and Hackathons.",
          color: "#ee3c26",
        },
        {
          title: "Six Months Software Intern",
          company: "Western Digital",
          company_url: "https://www.westerndigital.com/",
          logo_path: "wd.png",
          duration: "Jan 2019 - Jun 2019",
          location: "Bangalore, KA",
          description:
            "Involved in the Development of Diagnostic Framework in order to bypass Firmware Path to increase debug capability in later stages of SSD Development",
          color: "#0071C5",
        },
        {
          title: "Software Intern",
          company: "Western Digital",
          company_url: "https://www.westerndigital.com/",
          logo_path: "wd.png",
          duration: "Jun 2018 - Jul 2018",
          location: "Bangalore, KA",
          description:
            "Developed a Performance Counter Framework to help developers analyze defects in coding schemes. Analyzed results of this framework to optimize and remove the bottleneck in SSD Firmware",
          color: "#56A4D3",
        },
      ],
    },
    {
      title: "Research, Conferences and Leadership Experience",
      experiences: [
        {
          title: "Graduate Teaching Assistant",
          company: "Texas A&M University",
          company_url: "https://www.tamu.edu/",
          logo_path: "tamu.png",
          duration: "August 2023 - December 2023",
          location: "College Station, TX",
          description:
            "Working as a Graduate Teaching Assistant in the Computer Science Department for the course CSE 121: Program Design and Concepts. Involved in Teaching, Lab Supervision, Automation and Grading",
          color: "#f10000",
        },
        {
          title: "TAPIA'23 Conference Scholarship Recipient",
          company: "Richard TAPIA",
          company_url: "https://tapiaconference.cmd-it.org/",
          logo_path: "tapia.jpeg",
          duration: "2023",
          location: "Dallas",
          description:
            "Awarded the prestigious scholarship for Richard TAPIA conference 2023 and represented Texas A&M University at a conference held from September 13th to September 16th 2023.",
          color: "#4285F4",
        },
        {
          title: "Research Assistant",
          company: "University of Illinois Urbana-Champaign",
          company_url: "https://iot.cs.illinois.edu/people/",
          logo_path: "uiuc.png",
          duration: "2021",
          location: "Remote",
          description:
            "Research Internship under Dr. Matthew Caesar(UIUC) to create ExplainNet System. The idea was to create Intelligent Network Systems by extensive application of NLP and Generative AI.",
          color: "#4285F4",
        },
        {
          title: "Research Publication",
          company:
            "International Conference On Computational Vision and Bio-Inspired Computing",
          company_url:
            "https://link.springer.com/chapter/10.1007/978-981-16-9573-5_26",
          logo_path: "publication.jpeg",
          duration: "2021",
          location: "Remote",
          description:
            "Spirochaeta Bacteria Segmentation Using an Efficient Deep Learning Approach",
          color: "#D83B01",
        },
        {
          title: "Research Publication",
          company:
            "International Conference on Advancements in Computing, Communication and Technology",
          company_url: "",
          logo_path: "publication.jpeg",
          duration: "2021",
          location: "Remote",
          description:
            "Prediction of Celebrity Influence during election propaganda using Twitter Sentiment Analysis",
          color: "#D83B01",
        },
        {
          title: "Research Publication",
          company: "Science Globe International Conference",
          company_url:
            "https://www.digitalxplore.org/up_proc/pdf/377-153025525644-48.pdf",
          logo_path: "publication.jpeg",
          duration: "2018",
          location: "Thapar University",
          description: "Autonomous Tagging of Stackoverflow Questions",
          color: "#D83B01",
        },
        {
          title: "Managing Director",
          company: "Pushap Industries",
          company_url: " ",
          logo_path: "pushap.png",
          duration: " Aug 2020 - Jul 2022",
          location: " ",
          description:
            "Managed family business Pushap Industries by directing manfacturing workforce along with coordinating supply chain.",
          color: "#D83B01",
        },
        {
          title: "Hackathon",
          company: "Western Digital",
          company_url: " ",
          logo_path: "wd.png",
          duration: "2019",
          location: "Bangalore, KA",
          description:
            "Participated in Hackathon organized at Western Digital with idea of Distributed Faster Events Parsing using MapReduce(Hadoop).",
          color: "#D83B01",
        },
        {
          title: "Innovation Bazaar",
          company: "Western Digital",
          company_url: " ",
          logo_path: "wd.png",
          duration: "2020",
          location: "Bangalore, KA",
          description:
            "Participated in Innovation bazaar 2020 with idea for Data Deduplication to imporve Storage Utilisation",
          color: "#D83B01",
        },
        {
          title: "Howdy Hack 2023",
          company: "Texas A&M University",
          company_url: " ",
          logo_path: "tamu.png",
          duration: "2023",
          location: "College Station, TX",
          description:
            "HowdyHack 2023: Judged over 100 of projects ranging from AI/ML to CV and NLP Domains.",
          color: "#D83B01",
        },
        {
          title: "AIDP ML Summit 2024",
          company: "Apple",
          company_url: " ",
          logo_path: "apple.jpeg",
          duration: "2024",
          location: "Sunnyvale,CA",
          description:
            "Got selected and presented my work on Enhancing Sentiment Intelligence at Apple ML Summit 2024.",
          color: "#D83B01",
        },
        
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "Welcome to the Projects page, where innovation meets technology and Machine Learning! Here, I showcase a diverse range of projects that demonstrate my passion for exploring the latest tools and technologies. From captivating data visualizations to machine learning models, each project represents a unique endeavor that pushes the boundaries of what's possible. Whether it's diving into the depths of natural language processing or unraveling complex patterns in large datasets, these projects highlight my commitment to building impactful solutions.",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "rishabh.gif",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "Here you will find my blogs - Whenever I do something awesome, I do try my best to write a blog about it.",
    link: "https://rishabhbassi.hashnode.dev/",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      name: "Travelix",
      url: "https://travelix2.vercel.app/",
      description:
        "TRAVELIX is a personalized travel recommendation system that provides recommendations to users based on their preferences and travel history.",
      languages: [
        {
          name: "Ruby",
          iconifyClass: "logos-ruby",
        },
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Machine Learning",
          iconifyClass: "carbon:machine-learning",
        },
        {
          name: "User User CF",
          iconifyClass: "fluent-emoji:information",
        },
        {
          name: "Auto Rec",
          iconifyClass: "file-icons:adobe-mediaencoder",
        },
      ],
    },
    {
      name: "TA Management Portal",
      url:
        "https://www.youtube.com/watch?v=DCYwQhl1O4g&ab_channel=harmanpreetsingh",
      description:
        "The app handles the student applications for TA positions in the computer science department with various functionalities of the hiring manager, professor, and student.",
      languages: [
        {
          name: "NodeJS",
          iconifyClass: "logos-nodejs",
        },
        {
          name: "JavaScript",
          iconifyClass: "logos-javascript",
        },
        {
          name: "Ruby on Rails",
          iconifyClass: "logos-rails",
        },
      ],
    },
    {
      name: "Network Optimization Graphs",
      url: "https://github.com/bassirishabh/AlgoProject_Graphs",
      description:
        "Perform Network optimization by implementing a network routing protocol using the data structures and algorithms such as Graph, Heap, Make Union find.",
      languages: [
        {
          name: "Java",
          iconifyClass: "logos-java",
        },
        {
          name: "Algorithms",
          iconifyClass: "devicon:thealgorithms",
        },
        {
          name: "Data Structures",
          iconifyClass: "arcticons:dsb",
        },
      ],
    },
    {
      name: "Codex AI",
      url: "https://aicodexaviva.vercel.app/",
      description:
        "AI as a humanoid to solve various challeneges, tasks and coding problems.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Tensorflow",
          iconifyClass: "logos-tensorflow",
        },
        {
          name: "OpenAI",
          iconifyClass: "logos-openai",
        },
        {
          name: "React",
          iconifyClass: "logos-react",
        },
      ],
    },
    {
      name: "Humanoid",
      url: "https://www.youtube.com/watch?v=DXLhJYifnIE&ab_channel=Logerine",
      description:
        "Build a Humanoid ChatBot using TensorFlow; Identify objects using OCR, perform functions such as Personalized AI to help in interview preparation",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Raspberry Pi",
          iconifyClass: "devicon:raspberrypi",
        },
        {
          name: "Image Processing",
          iconifyClass: "bi:image-fill",
        },
        {
          name: "Natural Language Processing",
          iconifyClass: "vscode-icons:file-type-ai",
        },
      ],
    },
    {
      name: "Data Mining and Analysis",
      url: "https://github.com/bassirishabh/Project_DataMining",
      description:
        "Implemented supervised, unsupervised classification techniques such as XGBoost, Boruta, NestedCV on dataset consisting of 500 features and 1000 samples.",
      languages: [
        {
          name: "R",
          iconifyClass: "logos-r-lang",
        },
        {
          name: "XGBoost/PCA",
          iconifyClass: "arcticons:pcapdroid",
        },
        {
          name: "Data Mining",
          iconifyClass: "eos-icons:data-mining",
        },
      ],
    },
    {
      name: "Automatic Text Summarization",
      url: "https://github.com/bassirishabh/Text-Summarizer",
      description:
        "Utilize Natural Language Processing to summarize a source of data (webpage, Wikipedia, PDF), Results delivered via e-mail",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Django",
          iconifyClass: "akar-icons:django-fill",
        },
        {
          name: "Front End",
          iconifyClass: "simple-icons:frontendmentor",
        },
        {
          name: "Tensorflow",
          iconifyClass: "logos-tensorflow",
        },
      ],
    },
    {
      name: "Speak Translator",
      url: "https://github.com/bassirishabh/Text-Summarizer",
      description:
        "Application to translate image text to user specified language; Uses OCR to covert image to text; Translation API’s; TTS to convert translated text to audio",
      languages: [
        {
          name: "Android",
          iconifyClass: "logos-android",
        },
        {
          name: "Jupyter Notebook",
          iconifyClass: "logos-jupyter",
        },
        {
          name: "OCR",
          iconifyClass: "mdi:ocr",
        },
      ],
    },
    {
      name: "Combo Offers Portal",
      url: "https://github.com/bassirishabh/Combos",
      description:
        "Management portal for e-commerce websites for inventory management. Displays all products which can be brought together in a specified budget",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Django",
          iconifyClass: "logos-django",
        },
        {
          name: "Web App",
          iconifyClass: "carbon:application-web",
        },
      ],
    },
    {
      name: "Line Follower Robot",
      url: "https://github.com/bassirishabh/Combos",
      description:
        "Developed Buggy using ultrasound and other sensors to detects objects and takes appropriate turns/actions.",
      languages: [
        {
          name: "Arduino",
          iconifyClass: "logos-arduino",
        },
        {
          name: "Sensors",
          iconifyClass: "material-symbols:sensors",
        },
      ],
    },
    {
      name: "LangChain Chat with Your Data",
      url: "https://learn.deeplearning.ai/accomplishments/ac66f757-80b1-42c2-a06f-ad6f0feab9fb?usp=sharing",
      description:
        "Create a chatbot with LangChain to interface with your private data and documents.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Deep Learning",
          iconifyClass: "devicon:keras",
        },
      ],
    },
    {
      name: "Finetuning Large Language Models",
      url: "https://learn.deeplearning.ai/accomplishments/50d0f2c9-12ac-4576-8f0c-efab4ae1ba21?usp=sharing",
      description:
        "Discover when to use finetuning vs prompting for LLMs. Select suitable open-source models, prepare data, and train & evaluate for your specific domain.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
         {
          name: "Jupyter Notebook",
          iconifyClass: "logos-jupyter",
        },
      ],
    },
    {
      name: "Building Systems with the ChatGPT API",
      url: "https://learn.deeplearning.ai/accomplishments/470f002d-167f-42ea-b869-153d7531f38f?usp=sharing",
      description:
        "Learn to break down complex tasks, automate workflows, chain LLM calls, and get better outputs from LLMs. Evaluate LLM inputs and outputs for safety and relevance. ",
      languages: [
        {
          name: "NLP",
          iconifyClass: "carbon:ibm-watson-natural-language-understanding",
        },
        {
          name: "Jupyter Notebook",
          iconifyClass: "logos-jupyter",
        },
      ],
    },
    {
      name: "ChatGPT Prompt Engineering for Developers",
      url: "https://learn.deeplearning.ai/accomplishments/2c526cb2-9f9f-4b55-80ea-4a1547d76bad?usp=sharing",
      description:
        " Learn the fundamentals of prompt engineering for ChatGPT. Learn effective prompting, and how to use LLMs for summarizing, inferring, transforming, and expanding. ",
      languages: [
        {
          name: "NLP",
          iconifyClass: "carbon:ibm-watson-natural-language-understanding",
        },
        {
          name: "Hugging Face",
          iconifyClass: "emojione:hugging-face",
        },
      ],
    },
    {
      name: "Himachal Tourism Website",
      url: "https://github.com/bassirishabh/Portal-For-Tourism",
      description:
        "Developed Website using HTML,CSS and JS as forntend porject for Himachal Tourism",
      languages: [
        {
          name: "HTML",
          iconifyClass: "logos-html-5",
        },
        {
          name: "CSS",
          iconifyClass: "logos-css-3",
        },
        {
          name: "JS",
          iconifyClass: "vscode-icons:file-type-js",
        },
      ],
    },
    {
      name: "Bacteria Detection using Deep Learning",
      url: "https://github.com/bassirishabh/DeepLearning_BacteriaDetection",
      description:
        "Detection of bacteria using Convolutional Neural Network Deep Learning Techniques",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Jupyter Notebook",
          iconifyClass: "logos-jupyter",
        },
        {
          name: "Deep Learning",
          iconifyClass: "devicon:keras",
        },
      ],
    },
    {
      name: "Employee Management System",
      url: "",
      description:
        "Allows admins to mutate and manage employee details; Allows portal access and management to employees",
      languages: [
        {
          name: "Visual Basic",
          iconifyClass: "logos-dotnet",
        },
        {
          name: "Java",
          iconifyClass: "logos-java",
        },
        {
          name: "JSP",
          iconifyClass: "logos:jspm",
        },
        {
          name: "DBMS",
          iconifyClass: "mdi:database",
        },
        {
          name: "SQL",
          iconifyClass: "logos:mysql",
        },
      ],
    },
    {
      name: "Political Propoganda Influence using Twitter SA",
      url: "https://github.com/bassirishabh/Twitter_SA_Political",
      description:
        "Predict influence of celebrities during elections using sentiment analysis on Retweets of their followers.",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Twitter",
          iconifyClass: "logos-twitter",
        },
        {
          name: "NLP",
          iconifyClass: "carbon:ibm-watson-natural-language-understanding",
        },
        {
          name: "Hugging Face",
          iconifyClass: "emojione:hugging-face",
        },
      ],
    },
    {
      name: "Neural Machine Translation using Transformer",
      url: "https://github.com/bassirishabh/DeepLearning_CourseTAMU",
      description:
        "Implemented a Neural Machine Translation (NMT) using Transformer architecture for language translation with an emphasis on sequence-to-sequence learning. ",
      languages: [
        {
          name: "Python",
          iconifyClass: "logos-python",
        },
        {
          name: "Tensorflow",
          iconifyClass: "logos-tensorflow",
        },
        {
          name: "NLP",
          iconifyClass: "carbon:ibm-watson-natural-language-understanding",
        },
        {
          name: "Deep Lerning",
          iconifyClass: "devicon:keras",
        },
      ],
    },
    {
      name:
        "Parallelizing Strassen’s Matrix-Multiplication Algorithm with GPU & OpenMP",
      url: "https://github.com/bassirishabh/ParallelComputing_CourseTAMU",
      description:
        "Leveraging GPU computing, OpenMP for multi-threading, and MPI for distributed parallelism, the project achieved significant performance improvements.",
      languages: [
        {
          name: "C++",
          iconifyClass: "devicon:cplusplus",
        },
        {
          name: "OpenMP",
          iconifyClass: "iconoir:project-curve-3d",
        },
        {
          name: "GPU",
          iconifyClass: "mdi:gpu",
        },
        {
          name: "Parallel Computing",
          iconifyClass: "carbon:ibm-watson-natural-language-understanding",
        },
      ],
    },
    {
      name: "Personal Portfolio",
      url: "https://github.com/bassirishabh/me",
      description:
        "(This) Personal Portfolio developed using React to give insights into my life.",
      languages: [
        {
          name: "React",
          iconifyClass: "logos-react",
        },
        {
          name: "Netlify",
          iconifyClass: "logos-netlify",
        },
      ],
    },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
